import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import {
  Button,
  Grid,
  Row,
  Col,
  Collapse,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

// Component
import Reviews from './Reviews';
import Link from '../Link';
import ReportUserModal from '../ReportUserModal';
import ThankYouModal from '../ThankYouModal';
import noDataFound from '../../../public/siteImages/noDataFound.svg';

// Locale
import messages from '../../locale/jsonMessages';
import DashboardSideMenu from '../Dashboard/DashboardSideMenu';
import PanelWrapper from './ManageListing/PanelWrapper/PanelWrapper';
import { openReportUserModal } from '../../actions/modalActions';
import { ReportFlagSvgIcon, ShowLessSvgIcon, ShowMoreSvgIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
import { dateFormat } from '../../config';
import { formatLocalizedDate } from '../../helpers/formatLocateDate';

import cs from '../commonStyle.css';
import s from './ViewProfile.css';

class ViewProfile extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      location: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
      picture: PropTypes.string.isRequired,
      profileId: PropTypes.number.isRequired,
      reviewsCount: PropTypes.number.isRequired,
    }).isRequired,
    isUser: PropTypes.bool,
    loadMore: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    data: {
      createdAt: new Date(),
      picture: null
    },
    isUser: false
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      isProfileData: false
    }
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { data } = this.props;
    if (data?.info || data?.reviewsCount > 0) {
      this.setState({ isProfileData: true })
    }
  }

  handleClick() {
    this.setState({ open: !this.state.open })
  }

  setStateVariable = (variable) => {
    this.setState(variable)
  }

  render() {

    const { data, isUser, loadMore, openReportUserModal, profileId, userData, isAuthenticate, loading, locale } = this.props;
    const { open, isProfileData } = this.state;
    let date, count = 150, firstArray, restArray, dotString = false;
    date = formatLocalizedDate(data?.createdAt, locale, dateFormat?.fullMonthYearFormat)

    if (data?.info) {
      firstArray = data?.info?.slice(0, count);
      restArray = data?.info?.slice(count, data?.info?.length);
      if (restArray?.length > 0) {
        dotString = true;
      }
    }

    return (
      <Grid fluid className={cx(s.pageContainer, 'ViewProfile')}>
        <Row>
          <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
            <DashboardSideMenu isViewProfilePage isUser={isUser} data={data} />
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
            <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
              <div>
                <div>
                  <h1 className={s.profileTitle}>
                    <FormattedMessage {...messages.hey} />{' '} {data.firstName}!
                  </h1>
                  {data.location && <p className={s.profileInfo}>
                    <FormattedMessage {...messages.livesIn} /> {data.location}
                  </p>}
                  {
                    !isUser && isAuthenticate && <>
                      <ReportUserModal profileId={profileId} />
                      <ThankYouModal />
                      <Link
                        className='reportUserProfile'
                        onClick={openReportUserModal}
                      >
                        <ReportFlagSvgIcon />
                        <FormattedMessage {...messages.reportUser} />
                      </Link>
                    </>
                  }
                </div>
                {data?.info ?
                  <>
                    <div>
                      <div className={s.lineCss}></div>
                      <h3 className={s.subTitle}><FormattedMessage {...messages.aboutMe} /></h3>
                      <p className={cx(s.subContent, 'textWhite')}>
                        {!this.state.open && count >= 150 &&
                          <span className={cx(s.subText, s.lineBreak)}>  {firstArray} {dotString === true && <span>...</span>}</span>
                        }
                        {
                          restArray?.length > 0 &&
                          <div>
                            <Collapse in={open} onExiting={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                              <div> <span className={cx(s.subText, s.lineBreak)}>
                                {this.state.open && <>{firstArray}{restArray}</>}
                              </span></div>
                            </Collapse>
                            {
                              dotString && <div className={s.btnContainer}>
                                <div className={s.showHidePadding}>
                                  <Button
                                    bsStyle="link"
                                    className={cx(s.button, s.noPadding, s.btnLInk, s.showHideBtn, s.collapseBtn, 'bgTransparent')}
                                    onClick={() => this.handleClick()}
                                  >
                                    {this.state.open ? <FormattedMessage {...messages.closeAll} /> : <FormattedMessage {...messages.showDescription} />}

                                    {
                                      this.state.open && <ShowLessSvgIcon />
                                    }
                                    {
                                      !this.state.open && <ShowMoreSvgIcon />
                                    }
                                  </Button>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </p>
                    </div>
                  </> : !isProfileData && <div className={s.noDataImageContainer}><img src={noDataFound} alt='no data found image' /></div>
                }
                <PanelWrapper
                  userId={data.userId}
                  firstName={data.firstName}
                  setStateVariable={this.setStateVariable}
                />
              </div>
              {
                data?.reviewsCount > 0 && <Reviews
                  loading={loading}
                  reviewsCount={data?.reviewsCount}
                  data={data?.reviews}
                  loadMore={loadMore}
                />
              }
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapState = (state) => ({
  listSettingsData: state?.adminListSettingsData?.data,
  userData: state?.account?.data,
  isAuthenticate: state?.runtime?.isAuthenticated
});

const mapDispatch = {
  openReportUserModal,
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ViewProfile)));